import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import ja from 'vuetify/es5/locale/ja'
import '@fortawesome/fontawesome-free/css/all.css'

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: {
      ja
    },
    current: 'ja'
  },
  icons: {
    iconfont: 'fa',
  },
  theme: {
    themes: {
      light: {
        primary: '#175073',
        secondary: '#a1a5b9',
        accent: '#1976D2',
        error: '#b71c1c',
      },
    },
  }
});
